// import networkIcon from '@assets/svg/risk/Network.svg';
// import dataIcon from '@assets/svg/risk/Data.svg';
// import identityIcon from '@assets/svg/risk/Identity.svg';
// import lateralMovementIcon from '@assets/svg/risk/LateralMovement.svg';
// import encryptionAtRestIcon from '@assets/svg/risk/EncryptionAtRest.svg';
// import encryptionInEncryptionIcon from '@assets/svg/risk/EncryptionInEncryption.svg';
// import highAvailabilityIcon from '@assets/svg/risk/HighAvailability.svg';
// import loggingAndMonitoringIcon from '@assets/svg/risk/LoggingAndMonitoring.svg';

// import anomalousLogo from '@root/assets/svg/Cloud_Events/Anomalous.svg';
import anomalousLogo from '@root/assets/svg/Cloud_Events/anamolus-logo.svg';
import dataLogo from '@root/assets/svg/Cloud_Events/data-security-logo.svg';
// import encryptionLogo from '@root/assets/svg/Cloud_Events/Encryption.svg';
import encryptionLogo from '@root/assets/svg/Cloud_Events/encryption-logo.svg';
// import exposedSecretsLogo from '@root/assets/svg/Cloud_Events/ExposedSecrets.svg';
import exposedSecretsLogo from '@root/assets/svg/Cloud_Events/exposed-secret.svg';
// import highAvailabilityLogo from '@root/assets/svg/Cloud_Events/HighAvailability.svg';
import highAvailabilityLogo from '@root/assets/svg/Cloud_Events/high-availability.svg';
// import identityLogo from '@root/assets/svg/Cloud_Events/Identity.svg';
import identityLogo from '@root/assets/svg/Cloud_Events/identity-logo.svg';
// import loggingMonitoringLogo from '@root/assets/svg/Cloud_Events/LoggingMonitoring.svg';
import loggingMonitoringLogo from '@root/assets/svg/Cloud_Events/logging-and-monitoring.svg';
// import networkLogo from '@root/assets/svg/Cloud_Events/Network.svg';
import networkLogo from '@root/assets/svg/Cloud_Events/network-logo.svg';
// import noRiskLogo from '@root/assets/svg/Cloud_Events/No_Risk.svg';
import noRiskLogo from '@root/assets/svg/Cloud_Events/no-risk-logo.svg';
import threatLogo from '@root/assets/svg/Cloud_Events/Threat.svg';
// import userLogo from '@root/assets/svg/Cloud_Events/User.svg';
import userLogo from '@root/assets/svg/Cloud_Events/user-logo.svg';
// import vulnerabilitiesLogo from '@root/assets/svg/Cloud_Events/Vulnerabilities.svg';
import vulnerabilitiesLogo from '@root/assets/svg/Cloud_Events/vulnerabilities-logo.svg';
// import administratorLogo from '@root/assets/svg/Cloud_Events/administrator.svg';
import administratorLogo from '@root/assets/svg/Risk/RiskPriority/admin.svg';
// import credentialExposureLogo from '@root/assets/svg/Cloud_Events/credentialExposure.svg';
import credentialExposureLogo from '@root/assets/svg/Risk/RiskPriority/credential-exposure.svg';
// import inactiveLogo from '@root/assets/svg/Cloud_Events/inactive.svg';
import inactiveLogo from '@root/assets/svg/Risk/RiskPriority/inactive.png';
// import infrastructureModificationLogo from '@root/assets/svg/Cloud_Events/infrastructureModification.svg';
import infrastructureModificationLogo from '@root/assets/svg/Risk/RiskPriority/infrastructure-modification.svg';
// import misconfigurationIcon from '@root/assets/svg/Cloud_Events/misconfiguration.svg';
import credentialAccessIcon from '@root/assets/svg/Cloud_Events/credential_access.png';
import misconfigurationIcon from '@root/assets/svg/Cloud_Events/misconfigurationlogo.svg';
// import overPrivilegedLogo from '@root/assets/svg/Cloud_Events/overPrivileged.svg';
import overPrivilegedLogo from '@root/assets/svg/Risk/RiskPriority/over-privileged.svg';
// import privilegeEscalationLogo from '@root/assets/svg/Cloud_Events/privilegeEscalation.svg';
import dangerousPermissionLogo from '@root/assets/svg/Risk/RiskPriority/dangerous_permissions.png';
import privilegeEscalationLogo from '@root/assets/svg/Risk/RiskPriority/privilege-escalation.svg';

// import privilegedLogo from '@root/assets/svg/Cloud_Events/privileged.svg';
import privilegedLogo from '@root/assets/svg/Risk/RiskPriority/privledge.png';
// import reconnaissanceLogo from '@root/assets/svg/Cloud_Events/reconnaissance.svg';
import Malware from '@root/assets/svg/Cloud_Events/malware.svg';
import attackPathLogo from '@root/assets/svg/Risk/RiskPriority/attack_path.svg';
import reconnaissanceLogo from '@root/assets/svg/Risk/RiskPriority/reconnaissance.svg';
// import Malware from '@root/assets/svg/Threats/Malware.svg';
import RuntimeLogo from '@root/assets/svg/Cloud_Events/runtimelogo.svg';
// import RuntimeLogo from '@root/assets/svg/Threats/Runtime.svg';
import attackPreventionLogo from '@root/assets/svg/Cloud_Events/attack-prevention.svg';
import authenticationLogo from '@root/assets/svg/Cloud_Events/authentication.svg';
import complianceLogo from '@root/assets/svg/Cloud_Events/compliance.svg';
import documentationLogo from '@root/assets/svg/Cloud_Events/documentation.svg';
import environmentIsolationLogo from '@root/assets/svg/Cloud_Events/environment-isolation.svg';
import informationDisclosureLogo from '@root/assets/svg/Cloud_Events/information-disclosure.svg';
import infrastructureSecurityLogo from '@root/assets/svg/Cloud_Events/infrastructure-security.svg';
import inputValidationLogo from '@root/assets/svg/Cloud_Events/input-validation.svg';
import ComputeIcon from '@root/assets/svg/Top Services Categories/Compute.svg';

import inventoryManagementLogo from '@root/assets/svg/Cloud_Events/inventory-management.svg';
import lifecycleManagementLogo from '@root/assets/svg/Cloud_Events/lifecycle-management.svg';
import privacyLogo from '@root/assets/svg/Cloud_Events/privacy.svg';
import rateLimitingLogo from '@root/assets/svg/Cloud_Events/rate-limiting.svg';
import resourceManagementLogo from '@root/assets/svg/Cloud_Events/resource-management.svg';
import iamLogo from '@root/assets/svg/Cloud_Events/IAM.svg';

import riskAssessmentLogo from '@root/assets/svg/Cloud_Events/risk-assessment.svg';
import ApiLogo from '@root/assets/svg/Risk/RiskPriority/API.svg';
import ContainerLogo from '@root/assets/svg/Risk/RiskPriority/container.svg';
import operationsLogo from '@root/assets/svg/Risk/RiskPriority/operations.svg';
import SastLogo from '@root/assets/svg/Risk/RiskPriority/SAST.svg';
import ScaLogo from '@root/assets/svg/Risk/RiskPriority/SCA.svg';
import iaCLogo from '@root/assets/svg/Risk/Risks Icons/iac_misconfig.svg';
// Lateral Movement New Logo
import auditingMonitoring from '@root/assets/svg/Cloud_Events/auditing-monitoring.svg';
import authAccessControl from '@root/assets/svg/Cloud_Events/auth-access-control.svg';
import backupRecovery from '@root/assets/svg/Cloud_Events/backup-recovery.svg';
import clusterConfiguration from '@root/assets/svg/Cloud_Events/cluster-configuration.svg';
import cost from '@root/assets/svg/Cloud_Events/cost.svg';
import dataProtection from '@root/assets/svg/Cloud_Events/data-protection.svg';
import dataQuality from '@root/assets/svg/Cloud_Events/data-quality.svg';
import lateralMovementLogo from '@root/assets/svg/Cloud_Events/lateral-movement.svg';
import leastPrivilege from '@root/assets/svg/Cloud_Events/least-privilege.svg';
import monitoring from '@root/assets/svg/Cloud_Events/monitoring.svg';
import networkExposure from '@root/assets/svg/Cloud_Events/network-exposure.svg';
import performance from '@root/assets/svg/Cloud_Events/performance.svg';
import crownJewelLogo from '@root/assets/svg/Cloud_Events/crown-jewel-logo.svg';
import thirdParty from '@root/assets/svg/Cloud_Events/third-party-logo.svg';
import workloadSecurityLogo from '@root/assets/svg/Cloud_Events/workload-security-logo.svg';
import availabilityOperationsLogo from '@root/assets/svg/Cloud_Events/availability-operations.svg';
import identityAccessLogo from '@root/assets/svg/Cloud_Events/identity-access.svg';
import supplyChainLogo from '@root/assets/svg/Cloud_Events/supply-chain.svg';
import vulnerabilityManagementLogo from '@root/assets/svg/Cloud_Events/vulnerability-management.svg';
import workloadHardeningLogo from '@root/assets/svg/Cloud_Events/workload-hardening.svg';
import governanceHygieneLogo from '@root/assets/svg/Cloud_Events/governance-hygiene.svg';

import Tooltip from '@root/components/v2/ui-elements/Tooltip';
// import Tooltip from '@mui/material/Tooltip';

const IMAGE_MAP = {
  ['Data']: dataLogo,
  ['Credential Exposure']: credentialExposureLogo,
  ['Data Exposure']: dataLogo,
  ['Privilege Escalation']: privilegeEscalationLogo,
  ['Reconnaissance']: reconnaissanceLogo,
  ['Privileged']: privilegedLogo,
  ['Inactive']: inactiveLogo,
  // ['IAM']: iamLogo,
  ['Threat']: threatLogo,
  ['Administrator']: administratorLogo,
  ['Admin']: administratorLogo,
  ['Infrastructure Modification']: infrastructureModificationLogo,
  ['Over Privileged']: overPrivilegedLogo,
  ['Data Security']: dataLogo,
  ['Encryption']: encryptionLogo,
  ['Crown Jewel']: crownJewelLogo,

  ['Exposed Secrets']: exposedSecretsLogo,
  ['Internet Exposed']: exposedSecretsLogo,

  ['Network']: networkLogo,
  ['Network Security']: networkLogo,
  ['Anomalous']: anomalousLogo,
  ['Logging And Monitoring']: loggingMonitoringLogo,
  ['Logging & Monitoring']: loggingMonitoringLogo,
  ['Lateral Movement']: lateralMovementLogo,
  ['High Availability']: highAvailabilityLogo,
  ['Availability']: highAvailabilityLogo,
  ['Identity']: identityLogo,
  ['User']: userLogo,
  ['Vulnerabilities']: vulnerabilitiesLogo,
  ['Vulnerability']: vulnerabilitiesLogo,
  ['NoRisk']: noRiskLogo,
  ['Misconfiguration']: misconfigurationIcon,
  ['Configuration']: misconfigurationIcon,
  ['Malware']: Malware,
  ['Runtime']: RuntimeLogo,
  ['Runtime Behavior']: RuntimeLogo,
  ['Operational']: operationsLogo,
  ['Credential Access']: credentialAccessIcon,
  ['Access Control']: credentialAccessIcon,
  ['Access control']: credentialAccessIcon,

  // Kubernetes Risk Temp
  ['Effective Admin']: administratorLogo,
  ['Data Access']: dataLogo,
  ['High Privileged']: overPrivilegedLogo,
  ['IaC']: iaCLogo,
  ['IAM']: iamLogo,

  // ['']

  ['Misconfigurations']: misconfigurationIcon,
  ['Threats anomaly']: threatLogo,
  ['Anomaly Detection']: threatLogo,

  ['Dangerous permission']: dangerousPermissionLogo,
  ['Attack Path']: attackPathLogo,
  ['Attack path']: attackPathLogo,
  ['Attack paths']: attackPathLogo,
  ['Compute']: ComputeIcon,

  ['Environment Isolation']: environmentIsolationLogo,
  ['Infrastructure Security']: infrastructureSecurityLogo,
  ['Inventory Management']: inventoryManagementLogo,
  ['Resource Management']: resourceManagementLogo,
  ['Rate Limiting']: rateLimitingLogo,
  ['Authentication']: authenticationLogo,
  ['Input Validation']: inputValidationLogo,
  ['Documentation']: documentationLogo,
  ['Attack Prevention']: attackPreventionLogo,
  ['Information Disclosure']: informationDisclosureLogo,
  ['Compliance']: complianceLogo,
  ['Privacy']: privacyLogo,
  ['Lifecycle Management']: lifecycleManagementLogo,
  ['Lifecycle']: lifecycleManagementLogo,
  ['Risk Assessment']: riskAssessmentLogo,
  ['Network exposure']: networkExposure,
  ['Backup & recovery']: backupRecovery,
  ['Monitoring']: monitoring,
  ['Security Misconfiguration']: misconfigurationIcon,
  ['Auditing Monitoring']: auditingMonitoring,
  ['Auditing & Monitoring']: auditingMonitoring,
  ['Data protection']: dataProtection,
  ['Remote Code Execution']: dataProtection,
  ['Authentication & Access Control']: authAccessControl,
  ['Cluster Configuration']: clusterConfiguration,
  ['Data Quality']: dataQuality,
  ['Performance']: performance,
  ['Cost']: cost,
  ['Least Privilege']: leastPrivilege,
  ['Third Party']: thirdParty,
  ['Workload Security']: workloadSecurityLogo,
  ['Availability & Operations']: availabilityOperationsLogo,
  ['Availability And Operations']: availabilityOperationsLogo,
  ['Identity & Access']: identityAccessLogo,
  ['Identity And Access']: identityAccessLogo,
  ['Supply Chain']: supplyChainLogo,
  ['Vulnerability Management']: vulnerabilityManagementLogo,
  ['Workload Hardening']: workloadHardeningLogo,
  ['Governance & Hygiene']: governanceHygieneLogo,
  ['Governance And Hygiene']: governanceHygieneLogo,

  // Checkmarx
  ['SAST']: SastLogo,
  ['SCA']: ScaLogo,
  ['Container']: ContainerLogo,
  ['API']: ApiLogo,

  // Exposure Assessment levels
  ['Validated Exposure']: networkExposure,
  ['validated_exposure']: networkExposure,
  ['Potential Risk']: riskAssessmentLogo,
  ['potential_risk']: riskAssessmentLogo,
  ['Configuration Observed']: misconfigurationIcon,
  ['configuration_observed']: misconfigurationIcon,
  ['Confirmed Sensitive Exposure']: dataLogo,
  ['confirmed_sensitive_exposure']: dataLogo,
  ['Confirmed Impact']: threatLogo,
  ['confirmed_impact']: threatLogo,
};
// const COLOR_MAP = {
//   ['Data']: '#f9efff',
//   ['Credential Exposure']: '#fbf3eb',
//   ['Privilege Escalation']: '#f7e8e6',
//   ['Reconnaissance']: '#f4fdf9',
//   ['Privileged']: '#f1f2f3',
//   ['Inactive']: '#fff5e6',
//   ['Threat']: '#fdebe8',
//   ['Administrator']: '#f3f1ff',
//   ['Admin']: '#f3f1ff',
//   ['Infrastructure Modification']: '#eefaef',
//   ['Over Privileged']: '#f0f5ff',
//   ['Data Security']: '#f9efff',
//   ['Encryption']: '#f3f1ff',
//   ['Exposed Secrets']: '#fff2df',
//   ['Network']: '#e6efff',
//   ['Anomalous']: '#dedede',
//   ['Logging And Monitoring']: '#fff2f1',
//   ['Logging & Monitoring']: '#fff2f1',
//   ['Lateral Movement']: '#ffeaea',
//   ['High Availability']: '#ebeced',
//   ['Identity']: '#effcf5',
//   ['User']: '#fceaed',
//   ['Vulnerabilities']: '#f0f5ff',
//   ['NoRisk']: '#ecf9ec',
//   ['Misconfiguration']: '#ebf2ff',
//   ['Malware']: '#e6efff',
//   ['Runtime']: '#f9efff',

//   // Kubernetes Risk Temp
//   ['Effective Admin']: administratorLogo,
//   ['Data Access']: dataLogo,
//   ['High Privileged']: overPrivilegedLogo,

//   // ['']

//   ['Misconfigurations']: misconfigurationIcon,
//   ['Threats anomaly']: threatLogo,
// };
export const RiskTypeIcons = ({
  name,
  paddingRight = '5px',
  rowIndex,
  width = '25px',
  tooltip,
  height = '25px',
  // heightbg = '30px',
  // widthbg = '30px',
  count,
  bgNone = false,
}) => {
  return (
    <>
      {name && IMAGE_MAP[name] && count ? (
        <>
          <span style={{ marginRight: paddingRight, width: width, height: height }}>
            {tooltip ? (
              <Tooltip title={name} isIcon={true}>
                {/* <div
                  style={{
                    background: COLOR_MAP[name],
                    width: heightbg,
                    height: widthbg,
                    borderRadius: '7px',
                    display: 'flex',
                    padding: '3px',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}> */}
                <img
                  id={`${name?.toLowerCase()}-${rowIndex}`}
                  src={IMAGE_MAP[name]}
                  style={{ objectFit: 'contain', width: width, height: height }}
                  alt={name}
                />
                {/* </div> */}
              </Tooltip>
            ) : (
              // <div
              // style={{
              //   background: COLOR_MAP[name],
              //   width: heightbg,
              //   height: widthbg,
              //   borderRadius: '7px',
              //   display: 'flex',
              //   padding: '3px',
              //   justifyContent: 'center',
              //   alignItems: 'center',
              // }}>
              <img
                id={`${name?.toLowerCase()}-${rowIndex}`}
                src={IMAGE_MAP[name]}
                style={{ objectFit: 'contain', width: width, height: height }}
                alt={name}
              />
              // </div>
            )}
          </span>
          {count > 1 && <span style={{ color: 'navy' }}>{`+${count - 1}`}</span>}
        </>
      ) : name && IMAGE_MAP[name] ? (
        <span style={{ marginRight: paddingRight, width: width, height: height }}>
          {tooltip ? (
            <Tooltip title={name} isIcon={true}>
              {/* <div
                style={{
                  background: COLOR_MAP[name],
                  width: heightbg,
                  height: widthbg,
                  borderRadius: '7px',
                  display: 'flex',
                  padding: '3px',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}> */}
              <img
                id={`${name?.toLowerCase()}-${rowIndex}`}
                src={IMAGE_MAP[name]}
                style={{ objectFit: 'contain', width: width, height: height }}
                alt={name}
              />
              {/* </div> */}
            </Tooltip>
          ) : (
            <>
              {' '}
              {bgNone ? (
                <img
                  id={`${name?.toLowerCase()}-${rowIndex}`}
                  src={IMAGE_MAP[name]}
                  style={{ objectFit: 'contain', width: width, height: height }}
                  alt={name}
                />
              ) : (
                // <div
                //   style={{
                //     background: COLOR_MAP[name],
                //     width: heightbg,
                //     height: widthbg,
                //     borderRadius: '7px',
                //     display: 'flex',
                //     padding: '3px',
                //     justifyContent: 'center',
                //     alignItems: 'center',
                //   }}>
                <img
                  id={`${name?.toLowerCase()}-${rowIndex}`}
                  src={IMAGE_MAP[name]}
                  style={{ objectFit: 'contain', width: width, height: height }}
                  alt={name}
                />
                // </div>
              )}{' '}
            </>
          )}
        </span>
      ) : (
        name
      )}
    </>
  );
};
export const RiskCountTooltip = ({
  labels,
  customLength = 1, // New prop to control how many icons to show
}) => {
  if (!labels || labels.length === 0) return '-';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      {/* Show first customLength icons directly */}
      {customLength > 0 &&
        labels.slice(0, customLength).map((risk, index) => <RiskTypeIcons key={index} tooltip={true} name={risk} />)}

      {/* If there are more icons than customLength, show tooltip for remaining */}
      {labels.length > customLength ? (
        <Tooltip
          title={
            <div className="CountTooltip__Content">
              {labels.slice(customLength).map(label => (
                <div className="CountTooltip__Item" key={label}>
                  {label}
                </div>
              ))}
            </div>
          }
          arrow
          isIcon={true}>
          <span className="CountTooltip__CountContainer"> +{labels.length - customLength}</span>
        </Tooltip>
      ) : (
        <></>
      )}
    </div>
  );
};
